const { signupServiceUrl, mode } = window.siteInfo || {};

export const SIGNUP_SERVICE_URL = signupServiceUrl;
export const CALL_STATS_API = `${SIGNUP_SERVICE_URL}/services/getCallStats`;
export const LEAD_REGISTRATION_API = `${SIGNUP_SERVICE_URL}/services/leadRegistration`;
export const DEMO_REGISTRATION_API = `${SIGNUP_SERVICE_URL}/services/demoRegistration`;
export const INTEGRATION_REQUEST_API = `${SIGNUP_SERVICE_URL}/services/integrationRequest`;
export const ADD_NOTE_TO_LEAD_API = `${SIGNUP_SERVICE_URL}/services/addNoteToLead`;
export const UPDATE_CONTACT_API = `${SIGNUP_SERVICE_URL}/services/updateContact`;
export const COMPANY_CONTACT_UPDATE_API = `${SIGNUP_SERVICE_URL}/services/updateCompanyContact`;
export const DS_URL = mode === 'live' ? 'https://my.distributedsource.com/crm' : 'https://mystaging.distributedsource.com/crm';
export const BRANDID = '5a6e67a6-8bfd-45f5-a774-3462cb0c4e4c';
export const BRAND_NAME = 'AnswerConnect-US';

export const COOKIE_NAMES = {
  IS_REGISTERED: 'isregistered',
  IS_TEST_REGISTERED: 'isTestRegistered',
  IS_DEMO_REGISTERED: 'isDemoRegistered',
};

export const DEFAULT_COOKIE_ACTIVE_DAYS = 365;
